// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Paper = require("@mui/material/Paper").default;
var Button = require("@mui/material/Button").default;

function MM_cmp_export_state_to_url(Props) {
  var editoStateBase64 = Props.editoStateBase64;
  var onClose = Props.onClose;
  var $$location = window.location;
  var origin = $$location.origin;
  var pathname = $$location.pathname.replace(/\/v\d+\//g, "/latest/");
  var url = origin + pathname + "?editorState=" + editoStateBase64.replace(/\+/g, "-").replace(/\//g, "_");
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: React.createElement(Expln_React_Column.make, {
                    children: null
                  }, React.createElement(Expln_React_Row.make, {
                        spacing: 1,
                        children: null
                      }, React.createElement(Button, {
                            onClick: (function (param) {
                                MM_react_common.copyToClipboard(url);
                              }),
                            variant: "contained",
                            children: "Copy"
                          }), React.createElement(Button, {
                            onClick: (function (param) {
                                Curry._1(onClose, undefined);
                              }),
                            children: "Close"
                          })), React.createElement("pre", {
                        style: {
                          overflow: "auto"
                        }
                      }, url))
            });
}

var make = MM_cmp_export_state_to_url;

exports.make = make;
/* react Not a pure module */
